/**
 * Resolve an image URL for use in <img src="…">.
 *
 * Handles the three shapes we persist across the admin catalogue and
 * platform settings:
 *   1. Absolute http(s)://…       — CDN / paste-a-link workflow
 *   2. data:image/*;base64,…      — durable inline blob (Feb 2026+)
 *   3. /api/uploads/…             — legacy static-mount path (kept
 *                                    working until the admin re-uploads)
 *
 * The backend origin (`REACT_APP_BACKEND_URL`) is prepended only for
 * category 3 so it resolves through the FastAPI static mount. Data
 * URLs and absolute URLs pass through untouched.
 *
 * @param {string|null|undefined} url  Raw value from the database.
 * @returns {string|null} Fully qualified src, or null when input is empty.
 */
export function resolveImageUrl(url) {
  if (!url) return null;
  const s = String(url).trim();
  if (!s) return null;
  if (s.startsWith("data:")) return s;
  if (/^https?:\/\//i.test(s)) return s;
  const origin = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (s.startsWith("/")) return `${origin}${s}`;
  return s;
}
